export enum PanoramaTransactions {
  ADD_MESSAGE = 'add-message',
  WIDGET_LOAD_VIEWER = 'widget-load-viewer',
  WIDGET_LOAD_EDITOR = 'widget-load-editor',
  MESSAGES_LOAD_VIEWER = 'messages-load-viewer',
  WHATSAPP_SOCIAL_BUTTON_CLICK = 'whatsapp-social-button-click',
}
